export default __webpack_public_path__ + "59752d8f41de47f7229363dbdf7472e7.svg";